module.exports = __webpack_public_path__ + "28adc5a4c052c50f897b7c314e353eef.png";